import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "officeSelector",
    "maxInPerson",
    "remoteLink",
    "maxRemote",
    "programCheckbox",
    "selectAllProgramsCheckbox",
    "dateSelector", 
    "timeSelector",
    "durationSelector",
    "startTime",
    "validationPanel",
    "validationMessage"
  ]

  connect() { }

  validate(event) {
    const errors = this.validateForm();
    
    if (errors.length > 0) {
      event.preventDefault();
      this.showValidationPanel(errors.join("<br>"));
      return;
    }    
  }

  validateForm() {
    let validationErrors = [];

    validationErrors.push(...this.validateAttendanceModes());

    const selectedPrograms = this.programCheckboxTargets.filter(checkbox => checkbox.checked);
    if (selectedPrograms.length === 0) {
      validationErrors.push("At least one classroom program must be selected.");
    }

    validationErrors.push(...this.validateMeetingDates());
    
    return validationErrors;
  }

  validateMeetingDates() {
    const errors = [];
    const validDates = this.startTimeTargets
      .map(element => element.value)
      .filter(value => value && value.trim() !== "" && !isNaN(Date.parse(value)));

    if (validDates.length === 0) {
      errors.push("At least one meeting date must be added.");
      return errors;
    }

    this.startTimeTargets.forEach((startTimeElement, index) => {
      const hasValidDate = startTimeElement.value && 
                          startTimeElement.value.trim() !== "" && 
                          !isNaN(Date.parse(startTimeElement.value));
      
      if (hasValidDate) {
        const durationSelector = this.durationSelectorTargets[index];
        if (!durationSelector) {
          errors.push("Duration is required for meeting date.");
        } else {
          const durationValue = durationSelector.value?.trim();
          if (!durationValue || durationValue === "" || durationValue === "-") {
            errors.push("Duration is required for meeting date.");
          }
        }
      }
    });
    
    return errors;
  }

  validateAttendanceModes() {
    const errors = [];

    const officeId = (this.officeSelectorTarget?.value || "").trim();
    const hasOffice = officeId !== "";

    const remoteLink = (this.remoteLinkTarget?.value || "").trim();
    const hasRemote = remoteLink !== "";

    const maxInPerson = (this.maxInPersonTarget?.value || "").trim();
    const maxRemote = (this.maxRemoteTarget?.value || "").trim();

    if (!hasOffice && !hasRemote) {
      errors.push("Choose an in-person location or provide a remote link.");
      return errors;
    }

    if (hasOffice) {
      const maxInPersonAmount = Number(maxInPerson);
      if (maxInPerson === "") {
        errors.push("Max in-person is required when a location is selected.");
      } else if (Number.isNaN(maxInPersonAmount) || maxInPersonAmount <= 0) {
        errors.push("Max in-person must be greater than 0.");
      }
    }

    if (hasRemote) {
      const maxRemoteAmount = Number(maxRemote);
      if (maxRemote === "") {
        errors.push("Max remote is required when a video call link is provided.");
      } else if (Number.isNaN(maxRemoteAmount) || maxRemoteAmount <= 0) {
        errors.push("Max remote must be greater than 0.");
      }
    }

    return errors;
  }

  showValidationPanel(message) {
    const validationPanel = this.validationPanelTarget;
    const validationMessage = this.validationMessageTarget;
  
    validationMessage.innerHTML = message;
    validationPanel.hidden = false;
    validationMessage.hidden = false;
  }

  toggleAllPrograms(event) {
    const isChecked = event.target.checked;
    this.programCheckboxTargets.forEach(checkbox => {
      checkbox.checked = isChecked;
    });
  }

  updateSelectAll() {
    const allChecked = this.programCheckboxTargets.every(checkbox => checkbox.checked);
    const someChecked = this.programCheckboxTargets.some(checkbox => checkbox.checked);
    
    if (this.selectAllProgramsCheckboxTarget) {
      this.selectAllProgramsCheckboxTarget.checked = allChecked;
      this.selectAllProgramsCheckboxTarget.indeterminate = someChecked && !allChecked;
    }
  }
}
